(() => {
  const onReady = (fn) => {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };

  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  const safeParseJSON = (value) => {
    try { return JSON.parse(value); } catch (e) { return null; }
  };

  const formatMoney = (raw) => {
    if (raw === null || raw === undefined || raw === "") return "";
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        if (typeof raw === "number" && Number.isFinite(raw)) return window.Shopify.formatMoney(raw);
        const num = Number(raw);
        if (Number.isFinite(num)) return window.Shopify.formatMoney(Math.round(num));
      }
    } catch (e) {}
    try {
      const cents = typeof raw === "number" ? raw : Number(raw);
      if (Number.isFinite(cents)) {
        return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
          style: "currency",
          currency: "EUR",
        }).format(cents / 100);
      }
    } catch (e) {}
    const cents = Number(raw);
    if (Number.isFinite(cents)) {
      return `${(cents / 100).toFixed(2).replace(".", ",")} €`;
    }
    return String(raw);
  };

  const seededRandom = (seedStr) => {
    // Mulberry32 PRNG (déterministe)
    let a = hashStringToNumber(String(seedStr || ""));
    a |= 0;
    a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };


  const initGallery = (section) => {
    const mainImage = section.querySelector("[data-lfdl-gallery-main]");
    if (!mainImage) return;
    const thumbs = qsa(section, "[data-lfdl-gallery-thumb]");
    if (!thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const fullSrc = thumb.dataset.full;
        const alt = thumb.dataset.alt || "";
        if (fullSrc) {
          mainImage.src = fullSrc;
          if (alt) {
            mainImage.alt = alt;
          }
        }
        thumbs.forEach((btn) => btn.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  };

  const hashStringToNumber = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  };

  const getViewRange = (mode, handle) => {
    // Par défaut : 17 à 77 (produits + majorité des services)
    let min = 17;
    let max = 77;

    const h = (handle || "").toLowerCase();
    const m = (mode || "").toLowerCase();

    // Cas spécifique : "Recueil de mes pratiques"
    if (h.includes("recueil") && h.includes("pratique")) {
      return { min: 77, max: 111 };
    }

    // Visio : 33 à 111
    if (m.includes("visio")) {
      return { min: 33, max: 111 };
    }

    // 48h : 33 à 77
    if (m.includes("48h") || m.includes("48")) {
      return { min: 33, max: 77 };
    }

    // Formations : 17 à 77 (déjà par défaut)
    return { min, max };
  };

  const buildHourlyViewCount = (seed, range) => {
    const now = new Date();
    const hourKey = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}-${now.getHours()}`;

    const storageKey = `lfdlViewCount:${seed}:${range.min}-${range.max}`;
    const stored = safeParseJSON(localStorage.getItem(storageKey));

    if (stored && stored.hourKey === hourKey && typeof stored.value === "number") {
      return clamp(stored.value, range.min, range.max);
    }

    const stableSeed = `${seed}-${hourKey}-${range.min}-${range.max}`;
    const rand = seededRandom(stableSeed);

    const raw = Math.round(range.min + rand * (range.max - range.min));
    const value = clamp(raw, range.min, range.max);

    try {
      localStorage.setItem(storageKey, JSON.stringify({ hourKey, value }));
    } catch (e) {}

    return value;
  };

  const initViewCounter = (section) => {
  const wrapper = section.querySelector('[data-lfdl-viewer]');
  const counter = section.querySelector('[data-lfdl-view-count]');

  // Si le compteur est désactivé côté section, on ne doit rien afficher (ni icône, ni espace)
  if (!wrapper || !counter) return;

  const product_handle =
    counter.dataset.productHandle ||
    counter.getAttribute('data-product-handle') ||
    '';

  if (!product_handle) {
    // Pas de handle => on masque totalement (évite l'icône seule)
    wrapper.setAttribute('hidden', '');
    return;
  }

  // Affichage immédiat (évite "icône sans chiffre" pendant le fetch)
  wrapper.removeAttribute('hidden');
  counter.removeAttribute('hidden');
  counter.style.display = 'inline';
  counter.style.visibility = 'visible';

  // Fallback stable si l'API n'est pas dispo
  const mode = section.dataset.mode || '';
  const seed = counter.dataset.seed || product_handle;
  const range = getViewRange(mode, product_handle);
  counter.textContent = String(buildHourlyViewCount(hashStringToNumber(seed), range));

  const apiEndpoint = window.LFDL_VIEWS_API || '/apps/lfdl-views';
  const days = parseDays(counter.dataset.days || '7');

  fetch(`${apiEndpoint}?handle=${encodeURIComponent(product_handle)}&days=${encodeURIComponent(days)}`, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    credentials: 'same-origin'
  })
    .then((r) => r.json())
    .then((data) => {
      if (!data || typeof data.count !== 'number') return;
      counter.textContent = String(data.count);
    })
    .catch(() => {});
};


  const parseDays = (value) => {
    if (!value) return 0;
    const cleaned = String(value).replace("days", "");
    const parsed = parseInt(cleaned, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const parseCutDays = (value) => {
    const map = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
    if (!value) return [];
    return value
      .split(",")
      .map((item) => item.trim().toLowerCase())
      .map((item) => map[item])
      .filter((day) => day !== undefined);
  };

  const isCutDay = (date, cutDays) => cutDays.includes(date.getDay());

  const addBusinessDays = (date, days, cutDays) => {
    const result = new Date(date.getTime());
    let remaining = days;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (isCutDay(result, cutDays)) continue;
      remaining -= 1;
    }
    return result;
  };

  const getNextCutoff = (now, cutoff, cutDays) => {
    const next = new Date(now.getTime());
    next.setHours(cutoff.hours, cutoff.minutes, 0, 0);
    if (next <= now) {
      next.setDate(next.getDate() + 1);
    }
    while (isCutDay(next, cutDays)) {
      next.setDate(next.getDate() + 1);
      next.setHours(cutoff.hours, cutoff.minutes, 0, 0);
    }
    return next;
  };

  const formatDate = (date) => {
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || "fr", {
        day: "2-digit",
        month: "long",
      }).format(date);
    } catch {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}/${month}`;
    }
  };

  const formatTimeLeft = (from, to) => {
    const diffMs = Math.max(0, to.getTime() - from.getTime());
    const totalMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}min`;
  };

  const initDelivery = (section) => {
    const items = qsa(section, "[data-lfdl-delivery]");
    if (!items.length) return;
    const update = () => {
      const now = new Date();
      items.forEach((item) => {
        const ds = parseDays(item.dataset.ds);
        const de = parseDays(item.dataset.de);
        const template = item.dataset.template || "";
        const time = item.dataset.time || "18:00";
        const cutDays = parseCutDays(item.dataset.cut);
        const timeParts = time.split(":").map((part) => parseInt(part, 10));
        const cutoff = {
          hours: Number.isNaN(timeParts[0]) ? 18 : timeParts[0],
          minutes: Number.isNaN(timeParts[1]) ? 0 : timeParts[1],
        };
        const nextCutoff = getNextCutoff(now, cutoff, cutDays);
        const timeLeft = formatTimeLeft(now, nextCutoff);
        const startDate = addBusinessDays(nextCutoff, ds, cutDays);
        const endDate = addBusinessDays(nextCutoff, de, cutDays);
        const text = template
          .replace("[hour]", timeLeft)
          .replace("[date_start]", formatDate(startDate))
          .replace("[date_end]", formatDate(endDate));
        const target = item.querySelector(".lfdl-delivery__text");
        if (target) {
          target.textContent = text;
        }
      });
    };
    update();
    setInterval(update, 60 * 1000);
  };

  const initShareLinks = (section) => {
    const url = encodeURIComponent(window.location.href || "");
    qsa(section, "[data-share-template]").forEach((link) => {
      const template = link.dataset.shareTemplate || "";
      link.setAttribute("href", template.replace("{current-link}", url));
    });
    const copyBtn = section.querySelector("[data-lfdl-copy-link]");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        const link = window.location.href || "";
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(link);
          } else {
            const input = document.createElement("input");
            input.value = link;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
          }
          alert("Lien copie dans le presse-papiers");
        } catch {
          alert("Copie impossible");
        }
      });
    }
  };

  // ------------------------------------------------------------
  // LFDL - Ajout panier robuste (évite les spinners infinis)
  // ------------------------------------------------------------
  const getRoute = (key, fallback) => {
    try {
      if (typeof routes !== "undefined" && routes && routes[key]) return routes[key];
    } catch (e) {}
    if (window.routes && window.routes[key]) return window.routes[key];
    return fallback;
  };

  const updateCartBubble = async () => {
    const cartUrl = getRoute("cart_url", "/cart");
    const url = cartUrl.endsWith(".js") ? cartUrl : `${cartUrl}.js`;

    const controller = new AbortController();
    let timeoutId;

    try {
      timeoutId = window.setTimeout(() => {
        try {
          controller.abort();
        } catch (e) {}
      }, 8000);

      const res = await fetch(url, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: controller.signal
      });

      if (!res.ok) return;

      const cart = await res.json();
      const count = Number(cart && cart.item_count) || 0;

      document.querySelectorAll(".cart-count-bubble span[aria-hidden]").forEach((el) => {
        el.textContent = String(count);
      });
      document.querySelectorAll(".cart-count-bubble span.visually-hidden").forEach((el) => {
        el.textContent = count === 1 ? "1 article" : `${count} articles`;
      });
      document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
        bubble.style.display = count > 0 ? "inline-flex" : "none";
      });
    } catch (e) {
      console.warn("[LFDL] updateCartBubble failed", e);
    } finally {
      if (timeoutId) window.clearTimeout(timeoutId);
    }
  };

  const initAjaxAddToCart = (section) => {
    const forms = qsa(section, 'form[action*="/cart/add"]');
    if (!forms.length) return;

    forms.forEach((form) => {
      const btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      // On ne "hijack" que les formulaires LFDL qui demandent explicitement de rester sur la page
      const productForm = form.closest("product-form");
      const noRedirect =
        btn.hasAttribute("data-lfdl-no-redirect") ||
        (productForm && productForm.hasAttribute("data-lfdl-no-redirect")) ||
        (productForm && productForm.dataset && productForm.dataset.lfdlNoRedirect === "true");
      if (!noRedirect) return;

      form.addEventListener(
        "submit",
        async (evt) => {
          // IMPORTANT : ne surtout pas intercepter le bouton "Acheter maintenant" (boutons dynamiques Shopify)
          const submitter = evt.submitter;
          if (submitter && (submitter.classList.contains("shopify-payment-button__button") || submitter.closest(".shopify-payment-button"))) {
            return;
          }

          evt.preventDefault();
          evt.stopImmediatePropagation();

          const btn = submitter || form.querySelector('button[type="submit"]');
          if (!btn) return;
          if (btn.classList.contains("loading") || btn.hasAttribute("aria-disabled")) return;

          const labelEl = btn.querySelector(".lfdl-button-text");
          const spinner = btn.querySelector(".loading__spinner, .loading-overlay__spinner");
          const originalText = (labelEl ? labelEl.textContent : btn.textContent || "").trim();
          if (!btn.dataset.lfdlOriginalText) btn.dataset.lfdlOriginalText = originalText;

          btn.setAttribute("aria-disabled", "true");
          btn.classList.add("loading");
          if (spinner) spinner.classList.remove("hidden");

          const controller = new AbortController();
          let timeoutId;

          try {
            const baseAddUrl = getRoute("cart_add_url", "/cart/add");
            const cartAddUrl = (typeof baseAddUrl === "string" && baseAddUrl.endsWith(".js"))
              ? baseAddUrl
              : `${String(baseAddUrl || "/cart/add").replace(/\.js(\?.*)?$/, "")}.js`;

            const formData = new FormData(form);
            if (!formData.has("quantity")) formData.set("quantity", "1");

            timeoutId = window.setTimeout(() => {
              try {
                controller.abort();
              } catch (e) {}
            }, 12000);

            const res = await fetch(cartAddUrl, {
              method: "POST",
              body: formData,
              headers: { Accept: "application/json" },
              credentials: "same-origin",
              signal: controller.signal
            });

            let data = {};
            try {
              data = await res.json();
            } catch (e) {}

            if (!res.ok || (data && typeof data === "object" && data.status)) {
              const message = (data && data.description)
                ? data.description
                : (data && data.message)
                  ? data.message
                  : `HTTP ${res.status}`;
              throw new Error(message);
            }

            if (labelEl) {
              labelEl.textContent = "Article ajouté au panier";
            } else {
              btn.textContent = "Article ajouté au panier";
            }

            await updateCartBubble();

            // Reset optionnel (data-lfdl-reset)
            if (btn.hasAttribute("data-lfdl-reset")) {
              const delay = Number(btn.dataset.lfdlResetMs) || 2500;
              window.setTimeout(() => {
                const original = btn.dataset.lfdlOriginalText || originalText;
                if (labelEl) {
                  labelEl.textContent = original;
                } else {
                  btn.textContent = original;
                }
              }, delay);
            }
          } catch (err) {
            console.error("[LFDL] Add to cart (no redirect) failed:", err);
            if (labelEl) {
              labelEl.textContent = "Erreur";
            } else {
              btn.textContent = "Erreur";
            }
          } finally {
            if (timeoutId) window.clearTimeout(timeoutId);
            btn.removeAttribute("aria-disabled");
            btn.classList.remove("loading");
            if (spinner) spinner.classList.add("hidden");
          }
        },
        true
      );
});
  };

  const updateAvailability = (section, available) => {
    const notify = section.querySelector("[data-lfdl-notify]");
    if (notify) {
      notify.classList.toggle("is-hidden", Boolean(available));
    }
    const addButton = section.querySelector("[data-lfdl-add-button]");
    const soldoutBadge = section.querySelector("[data-lfdl-soldout-badge]");
    if (addButton) {
      const isAvailable = Boolean(available);
      const addText = addButton.dataset.addText || "Ajouter au panier";
      const soldOutText = addButton.dataset.soldoutText || "Victime de son succ\u00e8s!";
      const label = addButton.querySelector("[data-lfdl-add-label]");
      if (label) {
        label.textContent = isAvailable ? addText : soldOutText;
      }
      addButton.disabled = !isAvailable;
      addButton.setAttribute("aria-disabled", String(!isAvailable));
      addButton.classList.toggle("is-disabled", !isAvailable);
      if (soldoutBadge) {
        soldoutBadge.textContent = soldOutText;
      }
    }
    if (soldoutBadge) {
      soldoutBadge.classList.toggle("is-hidden", Boolean(available));
    }
  };

  const getCurrentVariantFromSection = (section) => {
    const picker = section.querySelector("variant-selects");
    if (!picker) return null;
    if (picker.currentVariant && typeof picker.currentVariant === "object") return picker.currentVariant;

    const json = picker.querySelector('script[type="application/json"]');
    const variants = safeParseJSON(json && json.textContent ? json.textContent : "[]");
    if (!Array.isArray(variants) || !variants.length) return null;

    const selectedOptions = Array.from(picker.querySelectorAll("select")).map((select) => select.value);
    if (!selectedOptions.length) return null;
    return (
      variants.find((variant) => {
        const options = Array.isArray(variant && variant.options) ? variant.options : [];
        if (options.length !== selectedOptions.length) return false;
        return options.every((opt, idx) => String(opt) === String(selectedOptions[idx]));
      }) || null
    );
  };

  const updatePriceDisplay = (section, variant) => {
    if (!section || !variant || typeof variant !== "object") return;
    const variantPrice = Number(variant.price);
    if (!Number.isFinite(variantPrice)) return;
    const compareAt = Number(variant.compare_at_price || 0);
    const onSale = Number.isFinite(compareAt) && compareAt > variantPrice;

    qsa(section, ".price").forEach((priceRoot) => {
      priceRoot.classList.toggle("price--on-sale", onSale);
      priceRoot.classList.toggle("price--sold-out", variant.available === false);

      const regularPriceNode =
        priceRoot.querySelector(".price__regular .price-item--regular:not(.variant-item__old-price)") ||
        priceRoot.querySelector(".price__regular .price-item--regular");
      if (regularPriceNode) {
        regularPriceNode.textContent = formatMoney(variantPrice);
      }

      const salePriceNode =
        priceRoot.querySelector(".price__sale .price-item--sale") ||
        priceRoot.querySelector(".price__sale .price-item--last");
      if (salePriceNode) {
        salePriceNode.textContent = formatMoney(variantPrice);
      }

      const compareNode = priceRoot.querySelector(".price__sale .price-item--regular");
      if (compareNode) {
        compareNode.textContent = formatMoney(onSale ? compareAt : variantPrice);
      }

      const compareWrap = compareNode ? compareNode.closest("span") : null;
      if (compareWrap && compareNode && compareNode.closest(".price__sale")) {
        compareWrap.style.display = onSale ? "" : "none";
      }
    });
  };

  const updateVariantBindings = (section, variant) => {
    const variantId = variant && typeof variant === "object" ? variant.id : variant;
    const variantTitle = variant && typeof variant === "object" ? (variant.title || "") : "";
    if (!variantId) return;
    const wishlist = section.querySelector(".wishlist-engine");
    if (wishlist) {
      wishlist.dataset.wishlistVariantId = variantId;
      wishlist.dataset.variant_id = variantId;
    }
    const calendar = section.querySelector(".calendar-booking");
    if (calendar) {
      calendar.dataset.variantId = variantId;
      if (variantTitle) calendar.dataset.variantTitle = variantTitle;
      calendar.dispatchEvent(new CustomEvent("lfdl:variant-change", { detail: { variantId: variantId, variantTitle: variantTitle } }));
    }
    const formInput = section.querySelector(`#product-form-${section.dataset.sectionId} [name=\"id\"]`);
    if (formInput) {
      formInput.value = variantId;
      formInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const syncVariantState = (section, variantMaybe) => {
    if (!section) return;
    const variant = (variantMaybe && typeof variantMaybe === "object") ? variantMaybe : getCurrentVariantFromSection(section);
    if (!variant) return;
    updateAvailability(section, variant.available);
    updateVariantBindings(section, variant);
    updatePriceDisplay(section, variant);
  };

  const initVariantSync = (section) => {
    const picker = section.querySelector("variant-selects");
    if (!picker) return;
    if (picker.dataset.lfdlVariantSyncBound === "true") return;
    picker.dataset.lfdlVariantSyncBound = "true";

    const sync = () => {
      window.requestAnimationFrame(() => {
        syncVariantState(section, picker.currentVariant || getCurrentVariantFromSection(section));
      });
    };

    picker.addEventListener("change", sync);
    sync();
  };

  const initSection = (section) => {
    initGallery(section);
    initViewCounter(section);
    initDelivery(section);
    initShareLinks(section);
    updateAvailability(section, section.dataset.initialAvailable === "true");
    initVariantSync(section);
    initAjaxAddToCart(section);
  };

  const subscribeVariants = () => {
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event || !event.data) return;
      const sectionId = event.data.sectionId;
      const section = document.querySelector(
        `[data-lfdl-product][data-section-id=\"${sectionId}\"]`
      );
      if (!section) return;
      const variant = event.data.variant;
      syncVariantState(section, variant);
    });
  };

    const initAll = (ctx) => {
    const scope = (ctx && ctx.querySelectorAll) ? ctx : document;
    qsa(scope, "[data-lfdl-product]").forEach((section) => {
      if (section.dataset.lfdlProductInited === "true") return;
      section.dataset.lfdlProductInited = "true";
      initSection(section);
    });
  };

  onReady(() => {
    initAll(document);
    subscribeVariants();

    document.addEventListener("shopify:section:load", (evt) => {
      initAll(evt && evt.target ? evt.target : document);
    });
  });
})();
